import { css } from "styled-components";

export const basicPrimaryStyle = css`
  color: var(--text-light);
  background-color: var(--button-primary);
  font-weight: var(--font-weight-semi-bold);

  svg:not([data-icon="loading"]) path {
    fill: transparent !important;
    stroke: var(--text-light) !important;
  }

  &:hover {
    background-color: var(--button-primary-hover) !important;
    color: var(--text-light) !important;
  }

  &:hover:not(.ant-btn-loading) {
    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--text-light) !important;
    }
  }

  &:focus {
    outline: none !important;
    color: var(--text-light) !important;
    background-color: var(--button-primary) !important;

    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--text-light) !important;
    }
  }

  &:focus-visible {
    outline: 1px solid var(--button-focused-shadow) !important;
    box-shadow: 0 0 0 2px var(--button-focused-shadow) !important;
  }

  &:active {
    background-color: var(--button-primary-clicked) !important;

    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--text-light) !important;
    }
  }

  &[disabled] {
    color: var(--text-light);
    background-color: var(--button-primary);
    opacity: 0.5;

    &:hover {
      color: var(--text-light);
      background-color: var(--button-primary);
      opacity: 0.5;
    }
  }
`;
